var _a, _b, _c, _d;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import view from './knowledgeManagerView.html';
import { groundingStatus } from '../../../../types';
import { debounce } from 'data/function';
import { ITimeoutService, translate } from 'angular';
import { AlertService } from 'modules/shared/AlertService';
import { AgentSegmentService } from '../../../../services/AgentSegmentService';
import { BUILDER_AGENT_KNOWLEDGE_CATALOG_CREATED, BUILDER_AGENT_KNOWLEDGE_CATALOG_OPENED } from '../../../../events';
const KNOWLEDGE_BASE_URL = '/tenant/knowledge-base';
let KnowledgeManager = class KnowledgeManager {
    static $inject = ['AlertService', '$translate', '$timeout', 'AgentSegmentService'];
    constructor(AlertService, $translate, $timeout, AgentSegmentService) {
        'ngInject';
        this.catalogs = [];
        this.agentCatalogs = [];
        //#region Properties
        this.hasChanges = false;
        this.searchTerm = '';
        //#endregion
        //#region Methods
        this.close = async () => {
            if (!this.hasChanges) {
                this.onClose?.();
            }
            else {
                await this.AlertService.show({
                    title: await this.$translate('knowledgeManager.alertLost.title'),
                    body: await this.$translate('knowledgeManager.alertLost.body'),
                    variant: 'warning',
                    icon: 'warning',
                    buttons: {
                        cancel: await this.$translate('knowledgeManager.alertLost.cancel'),
                        confirm: await this.$translate('knowledgeManager.alertLost.confirm'),
                    },
                    callback: {
                        cancelButtonAction: () => { },
                        confirmButtonAction: async () => { this.onClose?.(); },
                    },
                });
            }
        };
        this.updateFiltredCatalogs = () => {
            this.$timeout(() => {
                if (!this.catalogs) {
                    return;
                }
                const agentCatalogIds = this.agentCatalogs?.map(c => c.id);
                if (this.searchTerm === '') {
                    this.filtredCatalogs = this.catalogs.map(catalog => ({
                        ...catalog,
                        selected: agentCatalogIds.includes(catalog.id),
                    }));
                }
                else {
                    this.filtredCatalogs = this.catalogs
                        .filter((catalog) => catalog.name?.toLowerCase().trim().includes(this.searchTerm.toLowerCase().trim()))
                        .map(catalog => ({
                        ...catalog,
                        selected: agentCatalogIds.includes(catalog.id),
                    }));
                }
            });
        };
        this.onCatalogSearch = async (event) => {
            this.searchTerm = event.detail.value;
            this.debouncedFilter();
        };
        this.onCatalogSelectionChange = async (event) => {
            this.hasChanges = true;
            const catalogId = event.detail?.name;
            const catalog = this.catalogs.find(c => c.id === catalogId);
            if (!catalogId) {
                return;
            }
            if (event.detail?.checked !== undefined) {
                catalog.selected = event.detail.checked;
                if (event.detail.checked) {
                    this.agentCatalogs = [...this.agentCatalogs, catalog];
                }
                else {
                    this.agentCatalogs = this.agentCatalogs.filter(c => c.id !== catalog.id);
                }
            }
            this.updateFiltredCatalogs();
        };
        this.AlertService = AlertService;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.AgentSegmentService = AgentSegmentService;
    }
    //#endregion
    //#region Lifecycle Hooks
    $onInit() {
        this.debouncedFilter = debounce(this.updateFiltredCatalogs, 500);
        const agentCatalogIds = this.agentCatalogs?.map(c => c.id);
        this.catalogs = this.catalogs?.map(catalog => ({
            ...catalog,
            selected: agentCatalogIds.includes(catalog.id),
        }));
        this.filtredCatalogs = this.catalogs;
    }
    save() {
        this.agentCatalogs = this.agentCatalogs.map(agentCatalog => ({
            ...agentCatalog,
            status: groundingStatus.ACTIVE,
        }));
        this.onSave({ $agentCatalogs: this.agentCatalogs });
    }
    getBaseUrl() {
        return this.application.isSubflow ? `../../../../../${this.application.callerApplication.shortName}` : '../../../..';
    }
    getCatalogUrl(catalogId) {
        return `${this.getBaseUrl() + KNOWLEDGE_BASE_URL}/${catalogId}/documents`;
    }
    openKnowledgeBase() {
        this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CATALOG_CREATED);
        window.open(this.getBaseUrl() + KNOWLEDGE_BASE_URL, '_blank');
    }
    trackOpenCatalog(catalogId) {
        this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_KNOWLEDGE_CATALOG_OPENED, { catalogId });
    }
};
KnowledgeManager.$inject = ['AlertService', '$translate', '$timeout', 'AgentSegmentService'];
KnowledgeManager = __decorate([
    Component({
        template: view,
        controllerAs: '$ctrl',
        bindings: {
            onClose: '&',
            onSave: '&',
            application: '<',
            catalogs: '<',
            agentCatalogs: '<',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof AlertService !== "undefined" && AlertService) === "function" ? _a : Object, typeof (_b = typeof translate !== "undefined" && translate.ITranslateService) === "function" ? _b : Object, typeof (_c = typeof ITimeoutService !== "undefined" && ITimeoutService) === "function" ? _c : Object, typeof (_d = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _d : Object])
], KnowledgeManager);
export { KnowledgeManager };
